import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const StandardFilterField = iotsUtils.fromList(
	constants.organization.search.standardFilterFields
);

export const FilterField = iotsUtils.fromList(constants.organization.search.filterFields);
